import { createContext, useContext } from 'react';
import { FieldOption, StatusGroup, TaskType } from 'api/tasks';

interface StatusPickerContext {
  isOpen: boolean;
  toggle?: (e) => void;
  selected?: FieldOption<StatusGroup>;
  type: TaskType;
}

export const StatusPickerContext = createContext<StatusPickerContext>({
  isOpen: false,
  type: TaskType.Task,
});

export const useStatusPickerContext = () => {
  const context = useContext(StatusPickerContext);

  if (!context) {
    throw new Error(
      'This component must be used within a <StatusPicker> component.',
    );
  }

  return context;
};
